import { object, string, number, array ,date, InferType } from 'yup';
import { AccesoriesModel } from '../../../../../models/ItemModel';

const AccesoriesSchema = object({
    madantory: string(),
    optional: string()
})

export default AccesoriesSchema